import { Component, Input, AfterViewInit, Inject, EventEmitter, DOCUMENT } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-confirmation',
    templateUrl: './confirmation.component.html',
    styleUrls: ['./confirmation.component.css'],
    standalone: false
})
export class ConfirmationComponent {  //FB38075-Pawan Prajapati

  @Input() __iPopupHeight: number | string = 'auto';
  @Input() __sMessageTitle: string;
  @Input() __sMessage: string;
  @Input() __sMessageType: ConfirmationType;
  @Input() __bConfirmationVisible: boolean = false;
  __sOkBtnText: string = 'Ok';
  __sSecBtnText: string = null;
  __sCancelBtnText: string;
  __bIsCancelVisible: boolean = false;
  __bContinueDisbled: boolean = false;

  __sPromiseResolve: any;
  __sCSSClass: string = '';

  constructor(@Inject(DOCUMENT) private document: any, private route: ActivatedRoute, private router: Router) {
  }

  // fires on post view renders
  ngAfterViewInit(): void {
  }

  // fires on initialization
  ngOnInit() {
  }


  onConfirmationClick(bResult) {
    this.__bConfirmationVisible = false;
    if (this.__sPromiseResolve) {
      this.__sPromiseResolve(bResult);
      this.__bIsCancelVisible = false;
    }
  }

  show(confirmationType: ConfirmationType, sMessage: string, sTitle = "Confirmation", sOkBtnText = "Continue", sCancelBtnText = "Cancel", bIsCancelVisible = true, sSecBtnText = null,bContinueDisbled = false) {
    this.__bConfirmationVisible = true;
    this.__sMessageType = confirmationType;
    this.__sMessage = sMessage;
    this.__sMessageTitle = sTitle;
    this.__sOkBtnText = sOkBtnText;
    this.__sCancelBtnText = sCancelBtnText;
    this.__bIsCancelVisible = bIsCancelVisible;
    this.__sSecBtnText = sSecBtnText;
    this.__bContinueDisbled = bContinueDisbled;
    this.__sCSSClass = (this.__sMessageType == 'Success' ? 'popupSuccess' : (this.__sMessageType == 'Information' ? 'popupInformation' : (this.__sMessageType == 'Warning' || this.__sMessageType == 'Consistency warning' ? 'popupWarning' : (this.__sMessageType == 'Error' ? 'popupError' : ''))));
    return new Promise(resolve => {
      this.__sPromiseResolve = resolve;
    });
  }

  // FB38607-Pawan Prajapati
  showAlert(sMessage: string, popupHeight: number | string = 215, sTitle = "Alert", confirmationType = ConfirmationType.Error) {
    this.__bConfirmationVisible = true;
    this.__sMessageType = confirmationType;
    this.__sMessage = sMessage;
    this.__sOkBtnText = "Ok";
    this.__sMessageTitle = sTitle;
    this.__iPopupHeight = popupHeight;
    this.__sCSSClass = (this.__sMessageType == 'Success' ? 'popupSuccess' : (this.__sMessageType == 'Information' ? 'popupInformation' : (this.__sMessageType == 'Warning' ? 'popupWarning' : (this.__sMessageType == 'Error' ? 'popupError' : ''))));
  }
}

export enum ConfirmationType {
  Success = 'Success',
  Warning = 'Warning',
  Error = 'Error',
  Information = 'Information',
  Consistencywarning = "Consistency warning"
}
